import "./Contactus.css";
import Footer from "./Footer";
import mailIcon from "../assets/mail-b.png";


export default function ContactUs() {


    return (
        <section id="contact">
            <div className="con-container">
                <h1 className="con-title">Contact Us</h1>
                <div className="con-underline"></div>
                <div className="con-wrapper">
                    <h3>Suppliers</h3>
                    <h3>Supplier Development Program</h3>
                    <p>Our Purchasing team ensures a reliable and responsible supply chain that supports precision manufacturing.</p>
                    <p>Our Supplier Development Program focuses on enhancing quality, strengthening capabilities and promoting sustainable practices. Suppliers are assessed across multiple dimensions, including</p>
                    <ul>
                        <li>Quality Management Systems (QMS)</li>
                        <li>Integrated Management Systems (IMS)</li>
                        <li>Carbon footprint measurement and reduction</li>
                    </ul>
                    <p>Through structured performance monitoring, capability assessments, audits and training initiatives, we work collaboratively with our partners to build a responsible, innovative and future-ready supply chain.</p>
                    <h3>Supplier Contact</h3>
                    <p><img
                        src={mailIcon}
                        alt="mail"
                        style={{ width: "18px", height: "14px", marginRight: "2px", verticalAlign: "middle" }}
                    /> supplierenquiry@sundaramclayton.com</p>

                    <h3>Our Offices &amp; Plants</h3>

                    <div className="con-office-grid">

                        <div className="con-office-card">
                            <h4>Plant 1</h4>
                            <p>
                                Plot no. A-6/3A, SIPCOT Industrial Park,
                                Thervoy Kandigai, Gummidipoondi Taluk,
                                Thiruvallur District – 601 202
                            </p>
                            <p>Phone: 91-44-26258212</p>
                            <p>
                                <img src={mailIcon} alt="mail" className="con-mail-icon" />
                                scl@sundaramclayton.com
                            </p>
                        </div>

                        <div className="con-office-card">
                            <h4>Plant 2</h4>
                            <p>
                                No. B14, SIPCOT Industrial Growth Center, Oragadam,
                                Sriperumbudur Taluk, Kanchipuram District – 602 105
                            </p>
                            <p>Phone: 91-44-67103300</p>
                            <p>
                                <img src={mailIcon} alt="mail" className="con-mail-icon" />
                                scl@sundaramclayton.com
                            </p>
                        </div>

                        <div className="con-office-card">
                            <h4>Plant 3</h4>
                            <p>
                                AA5, VI Avenue, Auto Ancillary SEZ,
                                Natham sub post office, Mahindra World City, Chengalpattu,
                                Tamil Nadu, 603004
                            </p>
                            <p>
                                <img src={mailIcon} alt="mail" className="con-mail-icon" />
                                scl@sundaramclayton.com
                            </p>
                        </div>

                        <div className="con-office-card">
                            <h4>SC US</h4>
                            <p>
                                Sundaram Clayton USA, LLC
                                <br />
                                120 Casting Way, Ridgeville,
                                South Carolina – 29472, USA
                            </p>
                            <p>
                                <img src={mailIcon} alt="mail" className="con-mail-icon" />
                                sclna@sundaramclayton.com
                            </p>
                        </div>

                        <div className="con-office-card">
                            <h4>Registered Office</h4>
                            <p>
                                Chaitanya, No. 12, Khader Nawaz Khan Road,
                                Nungambakkam, Chennai – 600 006
                            </p>
                            <p>Phone: 044 28332115</p>
                            <p>Fax: 044 28332113</p>
                            <p>CIN: L51100TN2017PLC118316</p>
                            <p>
                                <img src={mailIcon} alt="mail" className="con-mail-icon" />
                                corpsec@sundaramclayton.com
                            </p>
                        </div>

                      

                        <div className="con-office-card">
                            <h4>Office</h4>
                            
                            <p>
                                MTH Road, Chennai, Tamil Nadu, 600050
                            </p>
                            <p>
                                <img src={mailIcon} alt="mail" className="con-mail-icon" />
                                scl@sundaramclayton.com
                            </p>
                        </div>

                        <div className="con-office-card">
    <h4>Investor Grievance</h4>
    <p>
        <img src={mailIcon} alt="mail" className="con-mail-icon" />
        corpserv@integratedindia.in
    </p>
    <p>
        <img src={mailIcon} alt="mail" className="con-mail-icon" />
        corpsec@sundaramclayton.com
    </p>
</div>

                    </div>

                </div>


            </div>
            <Footer />
        </section>
    );
}
